"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var reference_1 = require("../reference");
var CustomerReference = /** @class */ (function (_super) {
    __extends(CustomerReference, _super);
    function CustomerReference() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customerCode = '';
        _this.customerName = '';
        _this.customerAddress1 = '';
        _this.customerAddress2 = '';
        _this.customerCity = '';
        _this.customerState = '';
        _this.customerZipcode = '';
        _this.customerPhoneNumber = '';
        _this.customerEmail = '';
        _this.display = 'Customer Reference';
        return _this;
    }
    return CustomerReference;
}(reference_1.Reference));
exports.CustomerReference = CustomerReference;
